import React from "react";

const TeammateNickname = ({
  teammateNickname,
  setTeammateNickname,
  show,
  setShow,
}: {
  teammateNickname: string;
  setTeammateNickname: (newState: string) => void;
  show: boolean;
  setShow: (key: string) => void;
}) => {
  return (
    <div className="component">
      <div onClick={() => setShow("teammateNickname")} className="title">
        <p>
            Nickname&nbsp;
            {teammateNickname.length > 0 && (
              <span className="ml_3" style={{ color: "#007bff", fontWeight: 500 }}>
                ({teammateNickname.length > 30 ? teammateNickname.substring(0, 27) + '...' : teammateNickname})
              </span>
            )}
        </p>
        <i className={`${show && "rotate"} fa-solid fa-chevron-down`}></i>
      </div>
      {show && (
        <div className="search_input_container without_border_component">
          <input
            type="text"
            className="search_input"
            value={teammateNickname}
            onChange={(event) => {
                setTeammateNickname(event.target.value);
            }}
            placeholder="Enter your nickname..."
            autoFocus
          />
        </div>
      )}
    </div>
  );
};
export default TeammateNickname;
